import { render, staticRenderFns } from "./ButtonTutotial.vue?vue&type=template&id=826cec9a&scoped=true"
import script from "./ButtonTutotial.vue?vue&type=script&lang=js"
export * from "./ButtonTutotial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826cec9a",
  null
  
)

export default component.exports